import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Sabbatical week day 2: I fail at Octave",
  "description": "",
  "published": "2011-12-28T00:00:00.000Z",
  "redirect_from": ["/blog/sabbatical-week-day-2-i-fail-at-octave/swizec/3282"],
  "categories": "Artificial intelligence, GNU Octave, Machine learning, Math, MATLAB, Matrix (mathematics), Octave, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`I’m taking a sabbatical week over the holidays. This week’s posts will serve as a sort of report of what I got up to the previous day instead of the usual schedule – wish me luck that I achieve even half of what I’d like to.`}</em></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/12/300px-Programming_language_textbooks1.jpg",
        "alt": "English: A selection of programming language t...",
        "title": "English: A selection of programming language t..."
      }}></img></p>
    <p>{`After I managed to get the `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/sabbatical-week-day-1-toshl-and-toggl-datasets/swizec/3277",
        "title": "Sabbatical week day 1: Toshl and Toggl datasets"
      }}>{`toggl and toshl datasets`}</a>{` on Monday it was time to do something useful with them yesterday. Turns out, I'm not very good at doing useful things with datasets because my biggest achievement of the day was coming up with a plot of the data.`}</p>
    <p>{`You know that all awesome `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Data",
        "title": "Data"
      }}>{`data format`}</a>{` that is `}<a parentName="p" {...{
        "href": "http://json.org",
        "title": "JSON"
      }}>{`JSON`}</a>{`? Every `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Programming_language",
        "title": "Programming language"
      }}>{`programming language`}</a>{` except Java has a nice and easy interface for loading and saving right into native `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Data_structure",
        "title": "Data structure"
      }}>{`data structures`}</a>{`. This makes it perfect and all 'round awesome! So it seemed only natural that my node.js scripts for fetching data would be storing it in JSON for future use.`}</p>
    <p>{`Or so I thought.`}</p>
    <p>{`If there is one thing I learned in `}<a parentName="p" {...{
        "href": "http://ml-class.com"
      }}>{`ml-class`}</a>{` it's that one should always take some time to first model their `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Machine_learning",
        "title": "Machine learning"
      }}>{`machine learning algorithm`}</a>{` in a mathematical language like matlab/octave before implementing in a production-like language. Something about how all those `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Matrix_%28mathematics%29",
        "title": "Matrix (mathematics)"
      }}>{`matrix operations`}</a>{` are easier and how having a language created especially for the task makes it all that easier to play around.`}</p>
    <p>{`I guess octave is to machine learning as `}<a parentName="p" {...{
        "href": "http://www.adobe.com/products/indesign/main.html",
        "title": "Adobe InDesign"
      }}>{`InDesign`}</a>{` or Illustrator are to web design?`}</p>
    <p>{`Turns out not only doesn't `}<a parentName="p" {...{
        "href": "http://www.gnu.org/software/octave/",
        "title": "GNU Octave"
      }}>{`Octave`}</a>{` have a native way of reading JSON, but even when you find a library it is `}<em parentName="p">{`impossible`}</em>{` to say `}<em parentName="p">{`Here is a file, make it a string yo!`}</em>{` Just doesn't work. All files need to have a format or something ... it's really quite silly.`}</p>
    <p>{`Luckily there was a simple solution - just dump the data as a column of numbers and Octave couldn't have been happier about it.`}</p>
    <p>{`As mentioned, I didn't get very far, this graph is the extent of my achievements yesterday:`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2011/12/Selection_046-1024x345.png",
        "alt": "Toshl and Toggl plotted",
        "title": "Toshl and Toggl plotted"
      }}></img></p>
    <p>{`Just for fun I tried running linear regression on this data and, as expected, it failed horribly. The lowest cost is a function along the lines of `}<em parentName="p">{`y = `}<strong parentName="em">{`-6.5541e+88`}{`*`}{`x + `}</strong>{`-4.8840e+90`}</em>{` ... I'm not even sure coming up with fake-ish quadratic and cubic function elements would do much good in this case and since I only have a single parameter neural networks wouldn't do much good either.`}</p>
    <p>{`And either way, anything that comes even close to modeling this data will suffer from horrible overfitting and won't be much use anyway ... luckily I have some other ideas I can try.`}</p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://swizec.com/blog/sabbatical-week-day-1-toshl-and-toggl-datasets/swizec/3277"
        }}>{`Sabbatical week day 1: Toshl and Toggl datasets`}</a>{` (swizec.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.r-bloggers.com/visualizing-gestures-as-paths/"
        }}>{`Visualizing Gestures as Paths`}</a>{` (r-bloggers.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://wiki.answers.com/Q/Why_is_a_harp_shaped_how_it_is"
        }}>{`Why is a harp shaped how it is`}</a>{` (wiki.answers.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://stackoverflow.com/questions/7451757/octave-select-a-file"
        }}>{`Octave select a file?`}</a>{` (stackoverflow.com)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.tablix.org/~avian/blog/archives/2011/11/plotting_a_density_map/"
        }}>{`Plotting a density map`}</a>{` (tablix.org)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://flowingmotion.jojordan.org/2011/10/16/12-steps-to-running-gradient-descent-in-octave/"
        }}>{`12 steps to running gradient descent in Octave`}</a>{` (flowingmotion.jojordan.org)`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://flowingmotion.jojordan.org/2011/12/04/down-to-earth-principal-components-analysis-in-5-steps/"
        }}>{`Down-to-earth principal components analysis in 5 steps`}</a>{` (flowingmotion.jojordan.org)`}</li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=037d18ab-29b7-4c83-99e3-02ae84f3b1f3",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      